export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				type: 'compact-wrapper',
			},
			sidebar_setting: 'default-sidebar',
		},
		color: {
			primary_color: '#7366ff',
			secondary_color: '#f73164',
			mix_background_layout: 'light-only',
		},
		router_animation: 'fadeIn'
	}
}

// export class ConfigDB {
// 	static data = {
// 		 settings: {
// 			 layout_type:  'ltr',
// 		 sidebar: {
// 			 type: 'horizontal-wrapper enterprice-type',
// 		 },
// 		 sidebar_setting: 'default-sidebar', 
// 		 },
// 		 color: {
// 			 primary_color: '#012699', 
// 			 secondary_color: '#e71d2d', 
// 			 mix_background_layout: 'light-only', 
// 		 },
// 		 router_animation: ''
// 	 }
//    }

export default ConfigDB;




